import { useState } from "react";

import { Stack } from "@mui/material";

import { useIsMobile } from "hooks/useIsMobile";

import { DashboardItemLayout, PageLayout } from "../../../../layouts";
import { CarrierQuoteList } from "../CarrierQuoteList";
import { ShipmentList } from "../ShipmentListContainer";
import { HorizontalDashboard } from "./HorizontalDashboard";

export function Dashboard() {
  const reduceDashboardItemSpacing = useIsMobile({ maxWidth: 1300 });
  const useColumnLayout = useIsMobile({ maxWidth: 1350 });
  const [morePanelOpen, setMorePanelOpen] = useState(false);

  if (!useColumnLayout) {
    return (
      <HorizontalDashboard
        defaultLeftWidth={60}
        leftNode={
          <DashboardItemLayout
            sx={{ width: "100%", height: "100%", padding: "1rem" }}
          >
            <ShipmentList />
          </DashboardItemLayout>
        }
        rightNode={
          <CarrierQuoteList
            morePanelOpen={morePanelOpen}
            onMoreToggle={() => setMorePanelOpen((prev) => !prev)}
          />
        }
        rightExpanded={morePanelOpen}
        onLeftColumnClick={
          morePanelOpen ? () => setMorePanelOpen(false) : undefined
        }
      />
    );
  }

  return (
    <PageLayout>
      <Stack direction="column" spacing={reduceDashboardItemSpacing ? 4 : 8}>
        <DashboardItemLayout>
          <ShipmentList />
        </DashboardItemLayout>
        <DashboardItemLayout>
          <CarrierQuoteList />
        </DashboardItemLayout>
      </Stack>
    </PageLayout>
  );
}
